import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { SelectStyles } from "./Select.styles.js";
export var SelectPortalMenu = function SelectPortalMenu(_ref) {
  var anchorElement = _ref.anchorElement,
    cursor = _ref.cursor,
    isOpen = _ref.isOpen,
    isVirtualizationActive = _ref.isVirtualizationActive,
    children = _ref.children,
    maxHeight = _ref.maxHeight,
    maxWidth = _ref.maxWidth,
    _ref$excludeElementsF = _ref.excludeElementsFromOutsideClick,
    excludeElementsFromOutsideClick = _ref$excludeElementsF === void 0 ? [] : _ref$excludeElementsF,
    onOutsideMenuClick = _ref.onOutsideMenuClick;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    menuElement = _useState2[0],
    setMenuElement = _useState2[1];
  var rect = anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.getBoundingClientRect();
  var menuTop = rect ? rect.top + rect.height + window.scrollY : 0;
  var menuLeft = rect ? rect.left + window.scrollX : 0;
  var minWidth = anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.clientWidth;
  var elementsToIgnoreForOutsideClickDetection = useMemo(function () {
    return [].concat(_toConsumableArray(excludeElementsFromOutsideClick), [menuElement]);
  }, [excludeElementsFromOutsideClick, menuElement]);
  useEffect(function () {
    if (!isVirtualizationActive && isOpen) {
      var _menuElement$scrollTo, _menuElement$querySel;
      menuElement === null || menuElement === void 0 || (_menuElement$scrollTo = menuElement.scrollTo) === null || _menuElement$scrollTo === void 0 || _menuElement$scrollTo.call(menuElement, {
        top: Number(menuElement === null || menuElement === void 0 || (_menuElement$querySel = menuElement.querySelector('.active')) === null || _menuElement$querySel === void 0 ? void 0 : _menuElement$querySel.scrollHeight) * cursor
      });
    }
  }, [menuElement, cursor]);
  return isOpen ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(SelectStyles.PortalMenuStyled, {
    $top: menuTop,
    $left: menuLeft,
    $minWidth: minWidth,
    $maxHeight: maxHeight,
    $maxWidth: maxWidth,
    ref: setMenuElement,
    role: "listbox"
  }, /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideMenuClick: onOutsideMenuClick,
    excludeElementsFromOutsideClick: elementsToIgnoreForOutsideClickDetection
  }, children)), document.body) : null;
};
var OutsideClickHandler = function OutsideClickHandler(_ref2) {
  var children = _ref2.children,
    excludeElementsFromOutsideClick = _ref2.excludeElementsFromOutsideClick,
    onOutsideMenuClick = _ref2.onOutsideMenuClick;
  useEffect(function () {
    var onBodyClick = function onBodyClick(evt) {
      var target = evt.target;
      var clickWasOnIgnoredElement = excludeElementsFromOutsideClick.some(function (element) {
        return element && element.contains(target);
      });
      if (target.isConnected && !clickWasOnIgnoredElement) {
        onOutsideMenuClick === null || onOutsideMenuClick === void 0 || onOutsideMenuClick(evt.target);
      }
    };
    window.addEventListener('click', onBodyClick);
    return function () {
      return window.removeEventListener('click', onBodyClick);
    };
  }, [excludeElementsFromOutsideClick]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};